import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Form,
  ToggleButton,
  ToggleButtonGroup,
} from 'react-bootstrap';
import FormInput from '../../common/FormInput';
import FormLabel from '../../common/FormLabel';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import { partnerViewModel } from '../school/partner.view.model';
import { addTreehouseChallenge } from '../../../constants/error.constants';
import { useForm } from 'react-hook-form';
import { PARTNER_CHALLENGES } from '../../../constants/routes.constants';
import { ErrorMessage } from '@hookform/error-message';
import { useAuth } from '../../auth/Auth';
import { nextChallengeViewModel } from '../next_challenge/next.challenge.viewmodel';
import dropDownIc from '../../../assets/icon/tag-selectbox-arrow.svg';
import PartnerUnverifiedModal from '../school/PartnerUnverifiedModal';
import LoadButton from '../../common/LoadButton';
import UploadSection from '../school/media_upload/UploadSection';
import { schoolViewModel } from '../school/school.view.model';

const StandardChallenge = ({ expertId, agoraGroupId }) => {
  const history = useHistory();
  const { fetchAPI, partner } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isSetLoading, setIsSetLoading] = useState(false);
  const [youtubeUrl, setYoutubeUrl] = useState();
  const [youtubeErrors, setYoutubeErrors] = useState(false);
  const [challengeScope, setChallengeScope] = useState('public');
  const [showModal, setShowModal] = useState(false);
  const [time, setTime] = useState();
  const [date, setDate] = useState();
  const [endTime, setEndTime] = useState();
  const [endDate, setEndDate] = useState();
  const [image, setImage] = useState(null);
  const [tagList, setTaglist] = useState([]);
  const [challengeLength, setChallengeLength] = useState(7);
  const [selectedTag, setSelectedTag] = useState([]);
  const [selectedFriend, setSelectedFriend] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  const [imageName, setImageName] = useState('');
  const [showImageError, setShowImageError] = useState(false);
  const [uploadType, setUploadType] = useState('picture');
  const [picturePreview, setPicturePreview] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [video, setVideo] = useState(null);
  const [imageError, setImageError] = useState('');
  const [videoError, setVideoError] = useState('');
  const [branchOptions, setBranchOptions] = useState([
    // { value: _NOT_SELECTED, label: 'Select...' }
  ]);
  const taletreeFriendOptions = [
    { value: 'letsgo', label: 'LetsGo' },
    { value: 'uni', label: 'Uni' },
    { value: 'rushmore', label: 'Rushmore' },
    { value: 'cody', label: 'Cody' },
    { value: 'rooty', label: 'Rooty' },
    { value: 'doma', label: 'Doma' },
  ];
  const { register, watch, handleSubmit, setError, errors, getValues } =
    useForm({
      mode: 'onBlur',
    });

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 'auto',
      color: '#321b6d',
      fontWeight: '400',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  const getInterestBranches = () => {
    fetchAPI(nextChallengeViewModel.getTags, { limit: 99 })
      .then((res) => {
        setTaglist(res);
        res.map((tag) => {
          setBranchOptions((branchOptions) => [
            ...branchOptions,
            { value: tag.id, label: tag.tag, name: tag.tag },
          ]);
        });
      })
      .catch((err) => {});
  };

  const onSubmit = handleSubmit(async () => {
    const params = getValues();
    let isValid = true;

    // Check for image validation if the uploadType is 'picture'
    if (uploadType === 'picture' && !image) {
      setImageError('Please select an image.');
      isValid = false;
    } else {
      setImageError('');
    }

    // Check for video or youtube URL validation if the uploadType is 'video'
    if (uploadType === 'video' && !video && !youtubeUrl) {
      setVideoError('Please select a video or enter a YouTube URL.');
      isValid = false;
    } else {
      setVideoError('');
    }

    if (!isValid) return; // Prevent further submission if validation fails
    setIsDisable(true);
    setIsSetLoading(true);
    let tags = [];
    selectedTag.map((tag) => {
      tags.push(tag.value);
    });
    let data = {
      title: params['title'],
      description: params['description'],
      tags: tags,
      challenge_scope: challengeScope,
      created_by: expertId,
      // start_date_time: new Date(date + ' ' + time),
      // end_date_time: new Date(endDate + ' ' + endTime),
      // start_date_time: '',
      // end_date_time: '',
      deadline: 7,
    };
    if (youtubeUrl) {
      data.youtube_url = youtubeUrl;
    }
    if (selectedFriend) {
      data.character_type = selectedFriend;
    }

    try {
      createGroup(data);
    } catch (err) {
      console.error(err);
    }
  });

  const handleRedirect = () => {
    if (!partner.is_verified) {
      setShowModal(true);
    } else {
      history.push(PARTNER_CHALLENGES);
    }
  };

  const createGroup = async (challenge) => {
    try {
      challenge.agora_group_id = agoraGroupId || '';
      const type = partner?.user_type;
      partnerViewModel
        .addPartnerChallenge(challenge, type)
        .then((res) => {
          if (uploadType === 'video') {
            if (video) {
              schoolViewModel
                .addChallengeVideo(res.id, video)
                .then((res) => {
                  handleRedirect();
                })
                .catch((err) => {
                  console.log(err);
                  setIsDisable(false);
                  setIsLoading(false);
                });
            } else {
              handleRedirect();
            }
          }
          if (uploadType === 'picture') {
            partnerViewModel
              .addPartnerChallengeMedia(res.id, image, type)
              .then((res) => {
                handleRedirect();
              })
              .catch((err) => {
                console.log(err);
                setIsDisable(false);
                setIsLoading(false);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.error(err);
    }
  };

  const handleScopeChange = (val) => {
    setChallengeScope(val);
  };

  const handleBranchAdd = (selectedValue) => {
    setSelectedTag(selectedValue);
  };

  const handleFriendChoose = (e) => {
    setSelectedFriend(e.value);
  };

  useEffect(() => {
    getInterestBranches();
    setIsLoading(false);
  }, []);

  const handleYoutube = (e) => {
    if (e.target.value === '') {
      setYoutubeErrors(false);
      setIsDisable(false);
    } else {
      var regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
      var match = e.target.value.match(regExp);
      if (match && match[2].length == 11) {
        setYoutubeErrors(false);
        setIsDisable(false);
      } else {
        setIsDisable(true);
        setYoutubeErrors('Please enter a valid url');
      }
    }
    setYoutubeUrl(e.target.value);
    setVideoError(null);
  };

  return (
    <>
      <PartnerUnverifiedModal
        showModal={showModal}
        setShowModal={setShowModal}
      />
      <Container>
        <div className="d-flex justify-content-center a-challenge-partner">
          <div>
            <Form className="mt-50 mb-40" onSubmit={onSubmit}>
              <Form.Group className="mb-3" controlId="">
                <FormLabel>Title</FormLabel>
                <FormInput
                  name="title"
                  className="form-input"
                  ref={register({
                    required: addTreehouseChallenge.title.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="title"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  name="description"
                  as="textarea"
                  rows="3"
                  ref={register({
                    required: addTreehouseChallenge.description.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="description"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>
              <ToggleButtonGroup
                className="radio_styles"
                type="radio"
                name="challenge_scope"
                defaultValue="public"
                value={challengeScope}
                onChange={handleScopeChange}
              >
                <ToggleButton
                  id="tbg-radio-1"
                  value="public"
                  className={challengeScope === 'public' && 'gred-btn'}
                >
                  Public
                </ToggleButton>
                <ToggleButton
                  id="tbg-radio-2"
                  value="private"
                  className={challengeScope === 'private' && 'gred-btn'}
                >
                  Subscribers only
                </ToggleButton>
              </ToggleButtonGroup>
              <Form.Group className="mb-3" controlId="">
                <Form.Label>Select interest branches</Form.Label>
                <Select
                  name="hash_tag"
                  options={branchOptions}
                  isMulti
                  styles={customStyles}
                  required
                  value={selectedTag}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: '6px',
                    colors: {
                      ...theme.colors,
                      primary: '#80e4e1',
                    },
                  })}
                  onChange={handleBranchAdd}
                  inputRef={register({
                    required: addTreehouseChallenge.hast_tag.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="hash_tag"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>
              {/* <Form.Group className="mb-3" controlId="">
                <FormLabel>Challenge start date</FormLabel>
                <FormInput
                  type="date"
                  name="date"
                  min={new Date().toISOString().slice(0, 10)}
                  className="form-input"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  ref={register({
                    required: addTreehouseChallenge.date.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="date"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="">
                <FormLabel>Challenge start time</FormLabel>
                <FormInput
                  type="time"
                  name="time"
                  className="form-input"
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                  ref={register({
                    required: addTreehouseChallenge.time.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="time"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="">
                <FormLabel>Challenge end date</FormLabel>
                <FormInput
                  type="date"
                  name="endDate"
                  min={
                    date
                      ? new Date(date).toISOString().slice(0, 10)
                      : new Date().toISOString().slice(0, 10)
                  }
                  className="form-input"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  ref={register({
                    required: addTreehouseChallenge.endDate.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="endDate"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="">
                <FormLabel>Challenge end time</FormLabel>
                <FormInput
                  type="time"
                  name="endTime"
                  className="form-input"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  ref={register({
                    required: addTreehouseChallenge.endTime.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="endTime"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group> */}
              <Form.Group className="mb-3" controlId="">
                <Form.Label>Set time to complete</Form.Label>
                <select
                  name="challenge_length"
                  className="form-select challenge-style"
                  onChange={(e) => setChallengeLength(e.target.value)}
                >
                  <option value="7">1 week</option>
                </select>
                <img className="select-caret" src={dropDownIc} alt="" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="">
                <Form.Label>Select TaleTree friend</Form.Label>
                <Select
                  name="taletree_friend"
                  options={taletreeFriendOptions}
                  styles={customStyles}
                  required
                  // value={selectedFriend}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: '6px',
                    colors: {
                      ...theme.colors,
                      primary: '#80e4e1',
                    },
                  })}
                  onChange={handleFriendChoose}
                  inputRef={register({
                    required: addTreehouseChallenge.friend.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="taletree_friend"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>
              <UploadSection
                uploadType={uploadType}
                setUploadType={setUploadType}
                setImageName={setImageName}
                setImage={setImage}
                setShowImageError={setShowImageError}
                video={video}
                setVideo={setVideo}
                handleYoutube={handleYoutube}
                setYoutubeUrl={setYoutubeUrl}
                picturePreview={picturePreview}
                setPicturePreview={setPicturePreview}
                videoPreview={videoPreview}
                setVideoPreview={setVideoPreview}
                youtubeUrl={youtubeUrl}
                setImageError={setImageError}
                setNoVideoError={setVideoError}
              />
              {imageError && <div className="text-danger">{imageError}</div>}
              {videoError && <div className="text-danger">{videoError}</div>}
              {youtubeErrors && (
                <div className="text-danger">{youtubeErrors}</div>
              )}
              <LoadButton
                type="submit"
                text="Set challenge"
                className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                isDisabled={isDisable}
                isLoading={isSetLoading}
              />
            </Form>
          </div>
        </div>
      </Container>
    </>
  );
};
export default StandardChallenge;
